import VideoPlayerApp from './VideoPlayerApp'

export default VideoPlayerApp
// eslint-disable-next-line import/export
export * from './VideoPlayerApp'
